import type React from 'react';

function MedsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1545 1545"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Meds Icon</title>

      <g id="Layer_1-2" data-name="Layer 1">
        <rect width="1545" height="1545" fill="none" />

        <g id="Lager_2" data-name="Lager 2">
          <g id="Lager_1-2" data-name="Lager 1-2">
            <g id="Canvas">
              <g id="Fill_1" data-name="Fill 1">
                <path
                  id="Path_1"
                  data-name="Path 1"
                  d="M300.35,761.65h-99.23v-99.2H101.93v99.2H2.73v99.2H101.93v99.22h99.2v-99.22h99.23v-99.2ZM2.73,1098.94H300.35v-99.21H2.73v99.21Zm0-476.16H300.35v-99.2H2.73v99.2Zm1391.98-99.2c-71.97,0-116.8,40.23-116.8,114.46v24.74c0,55.68,11.6,99.78,54.93,146.2l59.56,65.74c30.94,33.26,33.26,49.49,33.26,89.73v10.84c0,27.84-8.51,41.76-25.52,41.77-17.82,0-26.31-11.6-26.31-34.81v-91.97h-101.34v103.61c0,77.36,39.45,119.12,117.58,119.12h20.12c85.87,0,125.31-55.69,125.31-142.32v-27.09c0-50.27-10.82-88.95-62.65-147.72l-58.8-65.75c-25.52-28.62-31.71-47.18-31.71-74.26v-13.17c0-19.34,4.65-30.94,22.45-30.94s22.43,11.65,22.43,30.16v71.97h99.01v-77.38c0-77.35-30.16-112.93-110.62-112.93h-20.89Zm-250.49,137.88c0-27.85-7.74-38.68-27.07-38.68h-23.21v388.35h20.12c23.99,0,30.16-12.34,30.16-40.23v-309.45Zm108.89-14.89v324.88c0,82.78-28.63,127.64-112.17,127.64h-146.2V523.57h146.2c77.35,0,112.17,35.59,112.17,122.98h0Zm-516.3-122.98v575.51h220.49v-103.65h-117.59v-141.56h103.33v-103.65h-103.33v-125.31h117.57v-101.34h-220.47Zm-357.1,0h126.87l39.46,290.85,39.42-290.85h118.36v575.51h-92.83v-340.35l-51.05,340.35h-38.68l-51.82-340.35v340.35h-89.72V523.57Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default MedsIcon;
